/**
 * Events Calendar — Untouchables Milton
 * Self-managed calendar using Shopify blog articles as event storage.
 */
(function () {
  'use strict';

  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];
  var DAY_MAP = { sun: 0, sunday: 0, mon: 1, monday: 1, tue: 2, tuesday: 2, wed: 3, wednesday: 3, thu: 4, thursday: 4, fri: 5, friday: 5, sat: 6, saturday: 6 };

  var CAT_COLORS = {
    'TCG': '#4CAF50',
    'Magic': '#4CAF50',
    'Pokemon': '#F44336',
    'Yu-Gi-Oh': '#9C27B0',
    'Hololive': '#2196F3',
    'Palworld': '#2196F3',
    'One Piece': '#FF9800',
    'Union Arena': '#00BCD4',
    'Gundam': '#E91E63',
    'Shadowverse': '#7C4DFF',
    'Riftbound': '#FF5722',
    'X-Wing': '#607D8B',
    'Cyberpunk': '#8BC34A',
    'default': '#ecbd79'
  };

  // Game images — mapped to asset filenames
  var CAT_IMAGES = {
    'Magic': 'cat-magic.jpg',
    'Yu-Gi-Oh': 'cat-yugioh.jpg',
    'Pokemon': 'cat-pokemon.jpg',
    'One Piece': 'cat-onepiece.jpg',
    'Union Arena': 'cat-ua.png',
    'Gundam': 'cat-gundam.jpg',
    'Shadowverse': 'cat-shadowverse.jpg',
    'Riftbound': 'cat-riftbound.jpg',
    'X-Wing': 'cat-xwing.jpg',
    'Cyberpunk': 'cat-cyberpunk.webp',
    'Hololive': 'cat-hololive.png',
    'Palworld': 'cat-palworld.png'
  };

  function EventsCalendar(container, events, settings) {
    this.container = container;
    this.rawEvents = events || [];
    this.settings = settings || {};
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth();
    this.view = this.settings.defaultView || 'calendar';
    this.activeFilters = [];
    this.allCategories = [];
    this.events = this.parseEvents(this.rawEvents);
    this.collectCategories();
    this.render();
  }

  EventsCalendar.prototype.parseEvents = function (raw) {
    var parsed = [];
    for (var i = 0; i < raw.length; i++) {
      var e = raw[i];
      if (!e.date) continue;
      var parts = e.date.split('-');
      if (parts.length !== 3) continue;
      parsed.push({
        id: e.id,
        title: e.title || 'Untitled Event',
        date: e.date,
        year: parseInt(parts[0]),
        month: parseInt(parts[1]) - 1,
        day: parseInt(parts[2]),
        time: e.time || '',
        endTime: e.endTime || '',
        categories: (e.categories || []).filter(function (c) { return c !== ''; }),
        price: e.price || '',
        ticketHandle: e.ticketHandle || '',
        recurring: e.recurring || '',
        location: e.location || this.settings.shopName || '',
        image: e.image || '',
        excerpt: e.excerpt || '',
        url: e.url || '',
        content: e.content || ''
      });
    }
    return parsed;
  };

  EventsCalendar.prototype.collectCategories = function () {
    var cats = {};
    for (var i = 0; i < this.events.length; i++) {
      for (var j = 0; j < this.events[i].categories.length; j++) {
        cats[this.events[i].categories[j]] = true;
      }
    }
    this.allCategories = Object.keys(cats).sort();
  };

  EventsCalendar.prototype.getCatColor = function (cat) {
    return CAT_COLORS[cat] || CAT_COLORS['default'];
  };

  EventsCalendar.prototype.getCatImage = function (cats) {
    // Return the first matching game image (skip 'TCG' since it's generic)
    for (var i = 0; i < cats.length; i++) {
      if (cats[i] !== 'TCG' && CAT_IMAGES[cats[i]]) {
        return this.settings.assetUrl ? this.settings.assetUrl.replace('PLACEHOLDER', CAT_IMAGES[cats[i]]) : '';
      }
    }
    return '';
  };

  EventsCalendar.prototype.getEventsForMonth = function (year, month) {
    var start = new Date(year, month, 1);
    var end = new Date(year, month + 1, 0);
    var result = [];

    for (var i = 0; i < this.events.length; i++) {
      var e = this.events[i];

      // Direct match
      if (e.year === year && e.month === month) {
        result.push(e);
      }

      // Recurring expansion
      if (e.recurring) {
        var recurrences = this.expandRecurring(e, start, end);
        for (var r = 0; r < recurrences.length; r++) {
          result.push(recurrences[r]);
        }
      }
    }

    // Filter duplicates (recurring might regenerate the original date)
    var seen = {};
    var unique = [];
    for (var k = 0; k < result.length; k++) {
      var key = result[k].id + '-' + result[k].date;
      if (!seen[key]) {
        seen[key] = true;
        unique.push(result[k]);
      }
    }

    // Apply category filters
    if (this.activeFilters.length > 0) {
      var filters = this.activeFilters;
      unique = unique.filter(function (ev) {
        for (var f = 0; f < filters.length; f++) {
          if (ev.categories.indexOf(filters[f]) >= 0) return true;
        }
        return false;
      });
    }

    return unique;
  };

  EventsCalendar.prototype.expandRecurring = function (event, rangeStart, rangeEnd) {
    var results = [];
    var parts = event.recurring.toLowerCase().split('-');
    if (parts.length < 2) return results;

    var pattern = parts[0];
    var dayName = parts.slice(1).join('-');
    var targetDay = DAY_MAP[dayName];
    if (targetDay === undefined) {
      // Try monthly-Nth-day pattern: "monthly-2nd-saturday"
      if (pattern === 'monthly' && parts.length >= 3) {
        return this.expandMonthlyNth(event, parts[1], parts[2], rangeStart, rangeEnd);
      }
      return results;
    }

    var originalDate = new Date(event.year, event.month, event.day);

    if (pattern === 'weekly') {
      var d = new Date(rangeStart);
      // Find first target day in range
      while (d.getDay() !== targetDay) d.setDate(d.getDate() + 1);

      while (d <= rangeEnd) {
        if (d >= originalDate && !(d.getFullYear() === event.year && d.getMonth() === event.month && d.getDate() === event.day)) {
          results.push(this.cloneEventForDate(event, d));
        }
        d.setDate(d.getDate() + 7);
      }
    } else if (pattern === 'biweekly') {
      var biStart = new Date(originalDate);
      // Find first occurrence on/after range start
      while (biStart < rangeStart) biStart.setDate(biStart.getDate() + 14);
      var bd = new Date(biStart);
      while (bd <= rangeEnd) {
        if (!(bd.getFullYear() === event.year && bd.getMonth() === event.month && bd.getDate() === event.day)) {
          results.push(this.cloneEventForDate(event, bd));
        }
        bd.setDate(bd.getDate() + 14);
      }
    }

    return results;
  };

  EventsCalendar.prototype.expandMonthlyNth = function (event, nthStr, dayStr, rangeStart, rangeEnd) {
    var results = [];
    var nthMap = { '1st': 1, '2nd': 2, '3rd': 3, '4th': 4, '5th': 5, 'first': 1, 'second': 2, 'third': 3, 'fourth': 4, 'last': -1 };
    var nth = nthMap[nthStr.toLowerCase()];
    var targetDay = DAY_MAP[dayStr.toLowerCase()];
    if (nth === undefined || targetDay === undefined) return results;

    var originalDate = new Date(event.year, event.month, event.day);
    var m = new Date(rangeStart.getFullYear(), rangeStart.getMonth(), 1);

    while (m <= rangeEnd) {
      var date = this.getNthWeekday(m.getFullYear(), m.getMonth(), nth, targetDay);
      if (date && date >= originalDate && date >= rangeStart && date <= rangeEnd) {
        if (!(date.getFullYear() === event.year && date.getMonth() === event.month && date.getDate() === event.day)) {
          results.push(this.cloneEventForDate(event, date));
        }
      }
      m.setMonth(m.getMonth() + 1);
    }

    return results;
  };

  EventsCalendar.prototype.getNthWeekday = function (year, month, nth, dayOfWeek) {
    if (nth === -1) {
      // Last occurrence
      var last = new Date(year, month + 1, 0);
      while (last.getDay() !== dayOfWeek) last.setDate(last.getDate() - 1);
      return last;
    }
    var d = new Date(year, month, 1);
    var count = 0;
    while (d.getMonth() === month) {
      if (d.getDay() === dayOfWeek) {
        count++;
        if (count === nth) return new Date(d);
      }
      d.setDate(d.getDate() + 1);
    }
    return null;
  };

  EventsCalendar.prototype.cloneEventForDate = function (event, date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    var dateStr = y + '-' + m + '-' + day;
    return {
      id: event.id + '-recur-' + dateStr,
      title: event.title,
      date: dateStr,
      year: y,
      month: date.getMonth(),
      day: date.getDate(),
      time: event.time,
      endTime: event.endTime,
      categories: event.categories,
      price: event.price,
      ticketHandle: event.ticketHandle,
      recurring: '',
      location: event.location,
      image: event.image,
      excerpt: event.excerpt,
      url: event.url,
      content: event.content,
      isRecurrence: true
    };
  };

  // ========================
  // RENDERING
  // ========================

  EventsCalendar.prototype.render = function () {
    var html = '';
    html += this.renderHeader();
    html += this.renderFilters();
    html += '<div class="ec-grid-wrapper' + (this.view !== 'calendar' ? ' hidden' : '') + '">';
    html += this.renderCalendarGrid();
    html += '</div>';
    html += '<div class="ec-list' + (this.view === 'list' ? ' active' : '') + '">';
    html += this.renderListView();
    html += '</div>';
    html += '<div class="ec-week-wrapper">';
    html += this.renderWeekView();
    html += '</div>';
    html += this.renderModal();
    this.container.innerHTML = html;
    this.bindEvents();
    this.bindSwipe();
  };

  EventsCalendar.prototype.renderHeader = function () {
    var now = new Date();
    var minMonth = new Date(now.getFullYear(), now.getMonth() - (this.settings.monthsBack || 3), 1);
    var maxMonth = new Date(now.getFullYear(), now.getMonth() + (this.settings.monthsAhead || 3), 1);
    var current = new Date(this.currentYear, this.currentMonth, 1);

    var prevDisabled = current <= minMonth ? ' disabled' : '';
    var nextDisabled = current >= maxMonth ? ' disabled' : '';

    return '<div class="ec-header">' +
      '<div class="ec-nav">' +
      '<button class="ec-nav-btn" data-action="prev"' + prevDisabled + '>&lsaquo;</button>' +
      '<span class="ec-month-title">' + MONTHS[this.currentMonth] + ' ' + this.currentYear + '</span>' +
      '<button class="ec-nav-btn" data-action="next"' + nextDisabled + '>&rsaquo;</button>' +
      '</div>' +
      '<div class="ec-view-toggle">' +
      '<button class="ec-view-btn' + (this.view === 'calendar' ? ' active' : '') + '" data-view="calendar">Calendar</button>' +
      '<button class="ec-view-btn' + (this.view === 'list' ? ' active' : '') + '" data-view="list">List</button>' +
      '</div>' +
      '</div>';
  };

  EventsCalendar.prototype.renderFilters = function () {
    if (this.allCategories.length === 0) return '';
    var html = '<div class="ec-filters">';
    html += '<button class="ec-filter-btn' + (this.activeFilters.length === 0 ? ' active' : '') + '" data-filter="all">All</button>';
    for (var i = 0; i < this.allCategories.length; i++) {
      var cat = this.allCategories[i];
      var isActive = this.activeFilters.indexOf(cat) >= 0;
      html += '<button class="ec-filter-btn' + (isActive ? ' active' : '') + '" data-filter="' + cat + '">';
      html += '<span class="ec-cat-dot" style="background:' + this.getCatColor(cat) + '"></span>';
      html += cat + '</button>';
    }
    html += '</div>';
    return html;
  };

  EventsCalendar.prototype.renderCalendarGrid = function () {
    var html = '<div class="ec-grid">';

    // Day headers
    for (var d = 0; d < 7; d++) {
      html += '<div class="ec-grid-header">' + DAYS[d] + '</div>';
    }

    // Calculate grid
    var firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
    var daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
    var prevMonthDays = new Date(this.currentYear, this.currentMonth, 0).getDate();
    var events = this.getEventsForMonth(this.currentYear, this.currentMonth);
    var today = new Date();

    // Group events by day
    var eventsByDay = {};
    for (var i = 0; i < events.length; i++) {
      var day = events[i].day;
      if (!eventsByDay[day]) eventsByDay[day] = [];
      eventsByDay[day].push(events[i]);
    }

    // Previous month padding
    for (var p = firstDay - 1; p >= 0; p--) {
      html += '<div class="ec-grid-cell ec-other-month"><span class="ec-day-number">' + (prevMonthDays - p) + '</span></div>';
    }

    // Current month days
    for (var c = 1; c <= daysInMonth; c++) {
      var isToday = (c === today.getDate() && this.currentMonth === today.getMonth() && this.currentYear === today.getFullYear());
      html += '<div class="ec-grid-cell' + (isToday ? ' ec-today' : '') + '">';
      html += '<span class="ec-day-number">' + c + '</span>';

      if (eventsByDay[c]) {
        var maxShow = 3;
        for (var e = 0; e < Math.min(eventsByDay[c].length, maxShow); e++) {
          var ev = eventsByDay[c][e];
          var color = ev.categories.length > 0 ? this.getCatColor(ev.categories[0]) : CAT_COLORS['default'];
          var pillImg = this.getCatImage(ev.categories);
          html += '<div class="ec-event-pill" style="background:' + color + '" data-event-id="' + ev.id + '">';
          if (pillImg) html += '<img class="ec-pill-img" src="' + pillImg + '" alt="">';
          html += ev.title + '</div>';
        }
        if (eventsByDay[c].length > maxShow) {
          html += '<div class="ec-more-events">+' + (eventsByDay[c].length - maxShow) + ' more</div>';
        }
      }

      html += '</div>';
    }

    // Next month padding
    var totalCells = firstDay + daysInMonth;
    var remaining = (7 - (totalCells % 7)) % 7;
    for (var n = 1; n <= remaining; n++) {
      html += '<div class="ec-grid-cell ec-other-month"><span class="ec-day-number">' + n + '</span></div>';
    }

    html += '</div>';
    return html;
  };

  EventsCalendar.prototype.renderListView = function () {
    var events = this.getEventsForMonth(this.currentYear, this.currentMonth);
    events.sort(function (a, b) { return a.day - b.day; });

    if (events.length === 0) {
      return '<div class="ec-empty">No events this month.</div>';
    }

    var html = '';
    for (var i = 0; i < events.length; i++) {
      var ev = events[i];
      var d = new Date(ev.year, ev.month, ev.day);
      var weekday = DAYS[d.getDay()];
      var monthStr = MONTHS[ev.month].substring(0, 3);

      var catImg = this.getCatImage(ev.categories);

      html += '<div class="ec-list-item" data-event-id="' + ev.id + '">';
      if (catImg) {
        html += '<div class="ec-list-image"><img src="' + catImg + '" alt="" class="ec-list-game-img"></div>';
      }
      html += '<div class="ec-list-date">';
      html += '<div class="ec-list-date-month">' + monthStr + '</div>';
      html += '<div class="ec-list-date-day">' + ev.day + '</div>';
      html += '<div class="ec-list-date-weekday">' + weekday + '</div>';
      html += '</div>';
      html += '<div class="ec-list-info">';
      html += '<div class="ec-list-title">' + ev.title + '</div>';
      html += '<div class="ec-list-meta">';
      if (ev.time) html += '<span>&#128339; ' + ev.time + (ev.endTime ? ' - ' + ev.endTime : '') + '</span>';
      if (ev.location) html += '<span>&#128205; ' + ev.location + '</span>';
      if (ev.price) {
        html += '<span>' + (ev.price === 'free' ? 'Free' : '$' + ev.price) + '</span>';
      }
      html += '</div>';
      if (ev.excerpt) html += '<div class="ec-list-excerpt">' + ev.excerpt + '</div>';
      if (ev.categories.length > 0) {
        html += '<div class="ec-list-cats">';
        for (var c = 0; c < ev.categories.length; c++) {
          html += '<span class="ec-cat-badge" style="background:' + this.getCatColor(ev.categories[c]) + '">' + ev.categories[c] + '</span>';
        }
        html += '</div>';
      }
      html += '</div></div>';
    }
    return html;
  };

  EventsCalendar.prototype.renderModal = function () {
    return '<div class="ec-modal-overlay" id="ec-modal">' +
      '<div class="ec-modal">' +
      '<button class="ec-modal-close" data-action="close-modal">&times;</button>' +
      '<div id="ec-modal-content"></div>' +
      '</div></div>';
  };

  EventsCalendar.prototype.showEventDetail = function (eventId) {
    var ev = this.findEvent(eventId);
    if (!ev) return;

    var html = '';
    var catImg = this.getCatImage(ev.categories);
    if (ev.image) {
      html += '<img class="ec-modal-image" src="' + ev.image + '" alt="' + ev.title + '">';
    } else if (catImg) {
      html += '<div class="ec-modal-game-img-wrap"><img class="ec-modal-game-img" src="' + catImg + '" alt="' + ev.title + '"></div>';
    }
    html += '<div class="ec-modal-body">';
    html += '<h2 class="ec-modal-title">' + ev.title + '</h2>';

    html += '<div class="ec-modal-meta">';
    var d = new Date(ev.year, ev.month, ev.day);
    html += '<span class="ec-modal-meta-item">&#128197; ' + DAYS[d.getDay()] + ', ' + MONTHS[ev.month] + ' ' + ev.day + ', ' + ev.year + '</span>';
    if (ev.time) html += '<span class="ec-modal-meta-item">&#128339; ' + ev.time + (ev.endTime ? ' - ' + ev.endTime : '') + '</span>';
    if (ev.location) html += '<span class="ec-modal-meta-item">&#128205; ' + ev.location + '</span>';
    html += '</div>';

    if (ev.categories.length > 0) {
      html += '<div class="ec-modal-cats">';
      for (var c = 0; c < ev.categories.length; c++) {
        html += '<span class="ec-cat-badge" style="background:' + this.getCatColor(ev.categories[c]) + '">' + ev.categories[c] + '</span>';
      }
      html += '</div>';
    }

    if (ev.price) {
      if (ev.price === 'free') {
        html += '<div class="ec-modal-price">Free Event</div>';
      } else {
        html += '<div class="ec-modal-price">$' + ev.price + '</div>';
      }
    }

    if (ev.content) {
      html += '<div class="ec-modal-description">' + ev.content + '</div>';
    } else if (ev.excerpt) {
      html += '<div class="ec-modal-description">' + ev.excerpt + '</div>';
    }

    html += '<div class="ec-modal-actions">';
    if (ev.ticketHandle && ev.ticketHandle !== 'pay-at-door') {
      html += '<a href="/products/' + ev.ticketHandle + '" class="ec-btn ec-btn-primary">Buy Tickets</a>';
      html += '<span class="ec-btn ec-btn-secondary" style="cursor:default;">or Pay at Door</span>';
    } else if (ev.ticketHandle === 'pay-at-door') {
      html += '<span class="ec-btn ec-btn-primary" style="cursor:default;">Pay at Door' + (ev.price && ev.price !== 'free' ? ' - $' + ev.price : '') + '</span>';
    } else if (ev.price === 'free') {
      html += '<span class="ec-btn ec-btn-primary" style="cursor:default;">Free Event</span>';
    }
    html += '</div>';

    html += '</div>';

    document.getElementById('ec-modal-content').innerHTML = html;
    document.getElementById('ec-modal').classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  EventsCalendar.prototype.findEvent = function (id) {
    // Search current month events (includes recurring)
    var events = this.getEventsForMonth(this.currentYear, this.currentMonth);
    for (var i = 0; i < events.length; i++) {
      if (String(events[i].id) === String(id)) return events[i];
    }
    return null;
  };

  EventsCalendar.prototype.closeModal = function () {
    document.getElementById('ec-modal').classList.remove('active');
    document.body.style.overflow = '';
  };

  // ========================
  // EVENT BINDING
  // ========================

  EventsCalendar.prototype.bindEvents = function () {
    var self = this;

    // Month navigation
    this.container.querySelectorAll('[data-action="prev"]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.navigateMonth(-1); });
    });
    this.container.querySelectorAll('[data-action="next"]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.navigateMonth(1); });
    });

    // View toggle
    this.container.querySelectorAll('[data-view]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.view = this.getAttribute('data-view');
        self.render();
      });
    });

    // Filters
    this.container.querySelectorAll('[data-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = this.getAttribute('data-filter');
        if (filter === 'all') {
          self.activeFilters = [];
        } else {
          var idx = self.activeFilters.indexOf(filter);
          if (idx >= 0) {
            self.activeFilters.splice(idx, 1);
          } else {
            self.activeFilters.push(filter);
          }
        }
        self.render();
      });
    });

    // Event clicks (pills + list items)
    this.container.querySelectorAll('[data-event-id]').forEach(function (el) {
      el.addEventListener('click', function () {
        self.showEventDetail(this.getAttribute('data-event-id'));
      });
    });

    // Modal close
    this.container.querySelectorAll('[data-action="close-modal"]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.closeModal(); });
    });

    // Close modal on overlay click
    var overlay = document.getElementById('ec-modal');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) self.closeModal();
      });
    }

    // Close on escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeModal();
    });

    // Week navigation
    this.container.querySelectorAll('[data-action="prev-week"]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.navigateWeek(-1); });
    });
    this.container.querySelectorAll('[data-action="next-week"]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.navigateWeek(1); });
    });
  };

  EventsCalendar.prototype.navigateMonth = function (delta) {
    this.currentMonth += delta;
    if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    } else if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    }
    this.currentWeekStart = null;
    this.render();
  };

  // ========================
  // MOBILE WEEK VIEW
  // ========================

  EventsCalendar.prototype.getWeekStart = function () {
    if (this.currentWeekStart) return new Date(this.currentWeekStart);
    var d = new Date();
    d.setDate(d.getDate() - d.getDay());
    d.setHours(0, 0, 0, 0);
    return d;
  };

  EventsCalendar.prototype.navigateWeek = function (delta) {
    var ws = this.getWeekStart();
    ws.setDate(ws.getDate() + (delta * 7));
    this.currentWeekStart = ws.getTime();
    this.currentMonth = ws.getMonth();
    this.currentYear = ws.getFullYear();
    this.render();
  };

  EventsCalendar.prototype.renderWeekView = function () {
    var ws = this.getWeekStart();
    var events = this.getEventsForMonth(this.currentYear, this.currentMonth);
    // Also get events from adjacent month if week spans two months
    var wsEnd = new Date(ws);
    wsEnd.setDate(wsEnd.getDate() + 6);
    if (wsEnd.getMonth() !== ws.getMonth()) {
      var adjEvents = this.getEventsForMonth(wsEnd.getFullYear(), wsEnd.getMonth());
      events = events.concat(adjEvents);
    }

    var html = '';

    // Swipe hint
    html += '<div class="ec-swipe-hint" id="ec-swipe-hint">&#8592; Swipe to navigate weeks &#8594;</div>';

    // Week nav
    html += '<div class="ec-week-nav">';
    html += '<button class="ec-nav-btn" data-action="prev-week">&#8249;</button>';
    var monthStr = MONTHS[ws.getMonth()];
    var endMonth = MONTHS[wsEnd.getMonth()];
    var label = monthStr === endMonth
      ? monthStr + ' ' + ws.getDate() + ' - ' + wsEnd.getDate() + ', ' + ws.getFullYear()
      : monthStr + ' ' + ws.getDate() + ' - ' + endMonth + ' ' + wsEnd.getDate();
    html += '<span class="ec-week-label">' + label + '</span>';
    html += '<button class="ec-nav-btn" data-action="next-week">&#8250;</button>';
    html += '</div>';

    // Week grid - 7 day columns
    html += '<div class="ec-week-grid">';
    for (var i = 0; i < 7; i++) {
      var day = new Date(ws);
      day.setDate(day.getDate() + i);
      var isToday = (day.toDateString() === new Date().toDateString());
      var dayEvents = events.filter(function (ev) {
        return ev.year === day.getFullYear() && ev.month === day.getMonth() && ev.day === day.getDate();
      });

      html += '<div class="ec-week-day' + (isToday ? ' ec-week-today' : '') + '">';
      html += '<div class="ec-week-day-header">';
      html += '<span class="ec-week-day-name">' + DAYS[i] + '</span>';
      html += '<span class="ec-week-day-num">' + day.getDate() + '</span>';
      html += '</div>';

      if (dayEvents.length > 0) {
        html += '<div class="ec-week-events">';
        for (var e = 0; e < dayEvents.length; e++) {
          var ev = dayEvents[e];
          var color = ev.categories.length > 0 ? this.getCatColor(ev.categories[0]) : CAT_COLORS['default'];
          var catImg = this.getCatImage(ev.categories);
          html += '<div class="ec-week-event" style="border-left:3px solid ' + color + '" data-event-id="' + ev.id + '">';
          if (catImg) html += '<img class="ec-week-event-img" src="' + catImg + '" alt="">';
          html += '<div class="ec-week-event-info">';
          html += '<div class="ec-week-event-title">' + ev.title + '</div>';
          if (ev.time) html += '<div class="ec-week-event-time">' + ev.time + '</div>';
          html += '</div></div>';
        }
        html += '</div>';
      }

      html += '</div>';
    }
    html += '</div>';

    return html;
  };

  // ========================
  // SWIPE SUPPORT
  // ========================

  EventsCalendar.prototype.bindSwipe = function () {
    var self = this;

    // Only bind once on the main container
    if (this._swipeBound) return;
    this._swipeBound = true;

    var startX = 0;
    var startY = 0;
    var distX = 0;
    var distY = 0;

    this.container.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      distX = 0;
      distY = 0;
    }, { passive: true });

    this.container.addEventListener('touchmove', function (e) {
      distX = e.touches[0].clientX - startX;
      distY = e.touches[0].clientY - startY;
      // Prevent page from sliding sideways during horizontal swipe
      if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > 10) {
        e.preventDefault();
      }
    }, { passive: false });

    this.container.addEventListener('touchend', function () {
      // Only swipe if horizontal movement > vertical (not scrolling)
      if (Math.abs(distX) > 50 && Math.abs(distX) > Math.abs(distY)) {
        var weekWrapper = self.container.querySelector('.ec-week-wrapper');
        if (weekWrapper && weekWrapper.offsetParent !== null) {
          if (distX > 0) {
            self.navigateWeek(-1);
          } else {
            self.navigateWeek(1);
          }
        }
      }
      distX = 0;
      distY = 0;
    });

    // Hide swipe hint after 3 seconds
    setTimeout(function () {
      var hint = document.getElementById('ec-swipe-hint');
      if (hint) {
        hint.style.opacity = '0';
        setTimeout(function () { hint.style.display = 'none'; }, 500);
      }
    }, 3000);
  };

  // ========================
  // INIT
  // ========================

  window.EventsCalendar = EventsCalendar;

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('events-calendar');
    if (!container) return;

    var events = window.__EVENTS_DATA__ || [];
    var settings = window.__EVENTS_SETTINGS__ || {};
    var sectionSettings = window.__EVENTS_SECTION_SETTINGS__ || {};

    Object.assign(settings, sectionSettings);

    new EventsCalendar(container, events, settings);
  });

})();
